<!-- https://8es9hr.axshare.com/#p=%E6%94%B6%E5%8F%96%E5%85%A5%E7%A4%BE%E8%B2%BB&g=1 -->
<!-- 收取入社費 -->
<template>
  <div>
    <ListForm
      :api="api"
      :id="id"
      labelPosition="top"
      formTitle="收取入社費"
      :recordToEdit="recordToEdit"
      :formType="formType"
      @createStockVoucher="createStockVoucher"
      @takeEntryFee="takeEntryFee"
      @summons="summons"
    >
      <div slot="footer" class="dialog-footer">
        <el-button plain @click="back">返回</el-button>
      </div>
    </ListForm>
    <el-dialog
      title="開立股金傳票"
      :visible.sync="dialogStockInvoice"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <el-form :model="currentEdit" label-position="top">
        <el-form-item label="請選擇借方會計科目">
          <el-select
            class="el-select"
            v-model="currentEdit.debitAccountTitleId"
            placeholder="請選擇會計科目"
            filterable
          >
            <el-option
              :value="accountTitle.id"
              :label="accountTitle.code + ' ' + accountTitle.name"
              v-for="accountTitle of accountTitles"
              :key="accountTitle.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="請輸入金額">
          <el-input
            v-model="currentEdit.stockAmount"
            v-on:input="resetAmount(currentEdit.stockAmount, 'stockAmount')"
            placeholder="請輸入金額"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="isSubmitting"
          @click="saveStockInvoice"
        >送出</el-button>
        <el-button 
          :disabled="isSubmitting" 
          @click="dialogStockInvoice = false"
        >取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Step from "@/components/Step.vue";
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";
export default {
  name: "transfer_in_fee",
  components: { ListForm, Step },
  props: {
    workFlowStatus: {
      type: Object,
      default() {
        return {};
      },
    },
    reviewInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      id: this.$route.params.id || "new",
      recordToEdit: {},
      api: "memberTransferCoopInApply",
      formType: [
        {
          label: "股金餘額",
          key: "memberStockAmount",
          type: "input",
          disabled: true,
          addcomma: true,
        },
        {
          type: "button",
          buttonType: "primary",
          plain: true,
          button: "開立股金傳票",
          buttonKey: "createStockVoucher",
        },
        {
          type: "span",
          span: "等待會計審查傳票...",
        },
        {
          label: "傳票日期",
          key: "memberStockVoucherDate",
          type: "date",
          disabled: true,
        },
        {
          label: "傳票號碼",
          key: "memberStockVoucherCode",
          type: "input",
          disabled: true,
        },
        {
          label: "入社費金額",
          key: "entryFee",
          type: "input",
          disabled: true,
          addcomma: true,
        },
        {
          type: "button",
          buttonType: "primary",
          plain: true,
          button: "從股金內扣",
          buttonKey: "takeEntryFee",
        },
        {
          type: "button",
          buttonType: "primary",
          plain: true,
          button: "自行開立傳票",
          buttonKey: "summons",
        },
        {
          label: "收取日期",
          key: "entryFeeVoucherDate",
          type: "date",
          disabled: true,
        },
        {
          label: "傳票號碼",
          key: "entryFeeVoucherCode",
          type: "input",
          disabled: true,
        },
      ],
      dialogStockInvoice: false,
      isSubmitting: false,
      currentEdit: {},
      accountTitles: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    resetAmount(amount, key) {
      return (this.currentEdit[key] = this.$addcomma(
        this.$removeComma(amount)
      ));
    },
    reviewData() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.recordToEdit = this.reviewInfo.reviewInfo;
        }, 200);
      });
    },
    getData() {
      const vm = this;
      const url = API[this.api] + `?action=getStockInfo&id=${this.id}`;
      const thenCB = (json) => {
        this.recordToEdit = Object.assign(
          {},
          this.recordToEdit,
          json.resultData.data
        );
        this.accountTitles = json.resultData.enumData.accountTitle;

        if (this.recordToEdit.entryFeeVoucherCode != null) {
          this.formType[6].vif = false;
          this.formType[7].vif = false;
        }

        if (this.recordToEdit.isStockVoucherReview) {
          this.formType[1].vif = false;
          this.formType[2].vif = true;
        } else {
          this.formType[1].vif = true;
          this.formType[2].vif = false;
        }

        if (this.recordToEdit.memberStockVoucherCode != null) {
          this.formType[1].vif = false;
          this.formType[2].vif = false;
        }
      };
      //回傳 promise，呼叫端才能等資料回來再解鎖按鈕
      return this.mAxiosGet(url, thenCB);
    },
    back() {
      this.$router.push({ name: "transfer_in" });
    },
    createStockVoucher() {
      this.dialogStockInvoice = true;
    },
    /**
     * 開立股金傳票，送出期間鎖住按鈕避免重複開立
     */
    async saveStockInvoice() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      let url = API[this.api] + "?action=createStockVoucher";
      const form = new FormData();
      form.append("id", this.id);
      form.append(
        "debitAccountTitleId",
        this.currentEdit.debitAccountTitleId || ""
      );
      form.append(
        "stockAmount",
        this.currentEdit.stockAmount
          ? this.$removeComma(this.currentEdit.stockAmount)
          : 0
      );
      try {
        await this.mAxiosPost(url, form);
        this.dialogStockInvoice = false;
        //先等畫面資料回來再解鎖，避免按鈕還沒隱藏就被再按一次
        await this.getData();
        this.showAjaxSuccessMsg();
      } catch (error) {
        //錯誤訊息已由 mAxiosPost 顯示，這裡只接住 reject
      } finally {
        this.isSubmitting = false;
      }
    },
    /**
     * 收取入社費，送出期間鎖住避免重複開立
     */
    async takeEntryFee() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      let url = API[this.api] + "?action=takeEntryFee";
      const form = new FormData();
      form.append("id", this.id);
      try {
        await this.mAxiosPost(url, form);
        await this.getData();
        this.showAjaxSuccessMsg();
      } catch (error) {
        //錯誤訊息已由 mAxiosPost 顯示，這裡只接住 reject
      } finally {
        this.isSubmitting = false;
      }
    },
    summons() {
      const { href } = this.$router.resolve({
        name: "coop_summons_edit",
      });
      window.open(href, "_blank", "toolbar=yes, width=1300, height=900");
    },
  },
};
</script>